import { useContext } from 'react'
import { NodeActionsContext } from './NodeActionsContextDef'

/**
 * Hook to access NodeActionsContext
 * Throws error if used outside of NodeActionsProvider
 */
export function useNodeActions() {
  const context = useContext(NodeActionsContext)
  if (!context) {
    throw new Error('useNodeActions must be used within a NodeActionsProvider')
  }
  return context
}
